"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferHint = void 0;
var _types = require("../types");
var _OfferTypes = require("./OfferTypes");
var _jsxRuntime = require("react/jsx-runtime");
const OfferHint = (param)=>{
    let { offer, dialogRef } = param;
    const { offerType } = offer;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            (0, _types.isBasicOfferHint)(offerType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferTypes.BasicOfferHint, {
                offer: offer
            }),
            (0, _types.isConceptOfferHint)(offerType) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferTypes.ConceptOfferHint, {
                dialogRef: dialogRef,
                offer: offer
            })
        ]
    });
};
exports.OfferHint = OfferHint;
